// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* sidebar.css */

:root {
  --scl--cms-layout-sidebar-width: 241px;
  --scl--cms-layout-sidebar-top: 64.5px;
  --scl--cms-layout-sidebar-bg: var(--neutralcolors-100);
  --scl--cms-layout-sidebar-border-color: rgba(133, 140, 149, 0.1);

  /* Item */
  --scl--cms-layout-sidebar-item-height: 43px;
  --scl--cms-layout-sidebar-item-padding: 0 22px;
  --scl--cms-layout-sidebar-item-gap: 12px;
  --scl--cms-layout-sidebar-item-hover-bg: var(--table-hover);
  --scl--cms-layout-sidebar-item-active-bg: var(--action-hover);

  /* Label */
  --scl--cms-layout-sidebar-label-color: var(--typography-text-body-secondary);
  --scl--cms-layout-sidebar-label-active-color: var(--typography-text-body-primary);
  --scl--cms-layout-sidebar-label-font-size: var(--font-size-16);
  --scl--cms-layout-sidebar-label-font-weight: var(--font-weight-regular);
  --scl--cms-layout-sidebar-label-active-font-weight: var(--font-weight-regular);

  /* Submenu */
  --scl--cms-layout-sidebar-submenu-item-height: 39px;
  --scl--cms-layout-sidebar-submenu-indent: 20px;
  --scl--cms-layout-sidebar-submenu-line-color: rgba(138, 139, 143, 0.2);
  --scl--cms-layout-sidebar-submenu-line-left: 30px;
  --scl--cms-layout-sidebar-submenu-active-bg: var(--action-hover);
  --scl--cms-layout-sidebar-submenu-active-label-color: var(--typography-text-body-primary);
  --scl--cms-layout-sidebar-submenu-hover-bg: var(--table-hover);
  --scl--cms-layout-sidebar-submenu-hover-label-color: var(--typography-text-body-primary);

  /* Notch */
  --scl--cms-layout-sidebar-notch-size: 10px;
  --scl--cms-layout-sidebar-notch-radius: 5px;
}

/* ========================================
   SIDEBAR CONTAINER
   ======================================== */

.scl--cms-layout-sidebar-container {
  position: fixed;
  left: 0;
  top: var(--scl--cms-layout-sidebar-top);
  width: var(--scl--cms-layout-sidebar-width);
  height: calc(100vh - var(--scl--cms-layout-sidebar-top));
  background: var(--scl--cms-layout-sidebar-bg);
  border-right: 0.5px solid var(--scl--cms-layout-sidebar-border-color);
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: none;
  -ms-overflow-style: none;
  z-index: 100;
}

.scl--cms-layout-sidebar-container::-webkit-scrollbar {
  display: none;
}

/* ========================================
   SIDEBAR MENU
   ======================================== */

.scl--cms-layout-sidebar-menu {
  display: flex;
  flex-direction: column;
  padding: 0;
  width: 100%;
}

/* ========================================
   MENU GROUP
   ======================================== */

.scl--cms-layout-sidebar-group {
  display: flex;
  flex-direction: column;
  width: 100%;
}

/* ========================================
   ITEM WRAPPER (holds pseudo notch divs + button)
   ======================================== */

.scl--cms-layout-sidebar-item-wrapper {
  position: relative;
  width: 100%;
}

.scl--cms-layout-sidebar-submenu-item-wrapper {
  position: relative;
  width: 100%;
}

/* ========================================
   MENU ITEM (Parent) - Button Reset + Styles
   ======================================== */

.scl--cms-layout-sidebar-item {
  /* Button reset */
  border: none;
  margin: 0;
  text-align: left;
  font: inherit;
  color: inherit;
  /* Custom styles */
  position: relative;
  z-index: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: var(--scl--cms-layout-sidebar-item-padding);
  gap: var(--scl--cms-layout-sidebar-item-gap);
  width: 100%;
  height: var(--scl--cms-layout-sidebar-item-height);
  cursor: pointer;
  background: var(--scl--cms-layout-sidebar-bg);
  box-sizing: border-box;
}

.scl--cms-layout-sidebar-item:focus {
  outline: 2px solid var(--primarypalette-blue);
  outline-offset: -2px;
}

.scl--cms-layout-sidebar-item:focus:not(:focus-visible) {
  outline: none;
}

.scl--cms-layout-sidebar-item--active {
  background: var(--scl--cms-layout-sidebar-item-active-bg);
}



/* ========================================
   MENU ITEM ICON
   ======================================== */

.scl--cms-layout-sidebar-item-icon {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.scl--cms-layout-sidebar-item-icon svg {
  width: 20px;
  height: 20px;
  display: block;
}

/* ========================================
   MENU ITEM LABEL
   ======================================== */

.scl--cms-layout-sidebar-item-label {
  flex: 1;
  font-family: var(--font-family-inter), -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-style: normal;
  font-weight: var(--scl--cms-layout-sidebar-label-font-weight);
  font-size: var(--scl--cms-layout-sidebar-label-font-size);
  line-height: var(--line-height-24);
  color: var(--scl--cms-layout-sidebar-label-color);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  user-select: none;
  transition: color 0.2s ease;
}


.scl--cms-layout-sidebar-item--active .scl--cms-layout-sidebar-item-label {
  font-weight: var(--scl--cms-layout-sidebar-label-active-font-weight);
  color: var(--scl--cms-layout-sidebar-label-active-color);
}

/* ========================================
   MENU ITEM CHEVRON
   ======================================== */

.scl--cms-layout-sidebar-item-chevron {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: transform 0.25s ease;
}

.scl--cms-layout-sidebar-item-chevron svg {
  display: block;
}

.scl--cms-layout-sidebar-item-chevron--open {
  transform: rotate(180deg);
}

/* ========================================
   SUBMENU CONTAINER
   ======================================== */

.scl--cms-layout-sidebar-submenu {
  display: flex;
  flex-direction: row;
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: var(--scl--cms-layout-sidebar-bg);
  position: relative;
}

.scl--cms-layout-sidebar-submenu--open {
  max-height: 600px;
}

/* ========================================
   SUBMENU LEFT BORDER LINE
   ======================================== */

.scl--cms-layout-sidebar-submenu-line {
  position: absolute;
  left: var(--scl--cms-layout-sidebar-submenu-line-left);
  top: 0;
  bottom: 0;
  width: 0.5px;
  background: var(--scl--cms-layout-sidebar-submenu-line-color);
  flex-shrink: 0;
  z-index: 3;
  pointer-events: none;
}

/* ========================================
   SUBMENU ITEMS WRAPPER
   ======================================== */

.scl--cms-layout-sidebar-submenu-items {
  display: flex;
  flex-direction: column;
  width: 100%;
}

/* ========================================
   SUBMENU ITEM - Button Reset + Styles
   ======================================== */

.scl--cms-layout-sidebar-submenu-item {
  /* Button reset */
  border: none;
  margin: 0;
  left: 43px;
  text-align: left;
  font: inherit;
  color: var(--scl--cms-layout-sidebar-label-color);
  /* Custom styles */
  position: relative;
  z-index: 0;
  display: flex;
  align-items: center;
  border-bottom-left-radius: 8px;
  border-top-left-radius: 8px;
  padding: 0 22px 0 var(--scl--cms-layout-sidebar-submenu-indent);
  height: var(--scl--cms-layout-sidebar-submenu-item-height);
  cursor: pointer;
  background: var(--scl--cms-layout-sidebar-bg);
  box-sizing: border-box;
  width: 100%;
  font-family: var(--font-family-inter), -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-style: normal;
  font-weight: var(--scl--cms-layout-sidebar-label-font-weight);
  font-size: var(--scl--cms-layout-sidebar-label-font-size);
  line-height: var(--line-height-24);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  user-select: none;
}

.scl--cms-layout-sidebar-submenu-item:focus {
  outline: none;
}

.scl--cms-layout-sidebar-submenu-item:focus-visible {
  outline: 2px solid var(--primarypalette-blue);
  outline-offset: -2px;
}

.scl--cms-layout-sidebar-submenu-item--active {
  background: var(--scl--cms-layout-sidebar-submenu-active-bg);
  color: var(--scl--cms-layout-sidebar-submenu-active-label-color);
  font-weight: var(--scl--cms-layout-sidebar-label-active-font-weight);
}

.scl--cms-pseudo-before {
  position: absolute;
  top: -7px;
  right: 0;
  width: var(--scl--cms-layout-sidebar-notch-size);
  height: 100%;
  pointer-events: none;
  transition: background-color 0.4s ease, opacity 0.4s ease;
  z-index: 2;
}

/* Layer 1 — active bg block that fills the notch area */
.scl--cms-pseudo-before.submenu-active::after {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: var(--scl--cms-layout-sidebar-notch-size);
  height: 7px;
  background: var(--scl--cms-layout-sidebar-item-active-bg);
  z-index: 1;
  opacity: 1;
}

/* Layer 2 — sidebar bg with border-bottom-right-radius that cuts the corner */
.scl--cms-pseudo-before.submenu-active::before {
  content: "";
  position: absolute;
  top: 0;
  right: 0;
  width: var(--scl--cms-layout-sidebar-notch-size);
  height: 7px;
  background-color: var(--scl--cms-layout-sidebar-bg);
  border-bottom-right-radius: var(--scl--cms-layout-sidebar-notch-radius);
  z-index: 2;
  opacity: 1;
}

/* First item: suppress top notch entirely — nothing above to carve into */
.scl--cms-pseudo-before.first-item-special::before,
.scl--cms-pseudo-before.first-item-special::after {
  display: none;
}

/* When not active, hide with opacity 0 */
.scl--cms-pseudo-before::before,
.scl--cms-pseudo-before::after {
  opacity: 0;
}

.scl--cms-pseudo-after {
  position: absolute;
  bottom: -7px;
  right: 0;
  width: var(--scl--cms-layout-sidebar-notch-size);
  height: 100%;
  pointer-events: none;
  z-index: 2;
  
}

/* Layer 1 — active bg block that fills the notch area */
.scl--cms-pseudo-after.submenu-active::after {
  content: "";
  position: absolute;
  bottom: 0;
  right: 0;
  width: var(--scl--cms-layout-sidebar-notch-size);
  height: 7px;
  background: var(--scl--cms-layout-sidebar-item-active-bg);
  z-index: 1;
  transition: background-color 0.2s ease, opacity 0.2s ease;
  opacity: 1;
}

/* Layer 2 — sidebar bg with border-top-right-radius that cuts the corner */
.scl--cms-pseudo-after.submenu-active::before {
  content: "";
  position: absolute;
  bottom: 0;
  right: 0;
  width: var(--scl--cms-layout-sidebar-notch-size);
  height: 7px;
  background-color: var(--scl--cms-layout-sidebar-bg);
  border-top-right-radius: var(--scl--cms-layout-sidebar-notch-radius);
  z-index: 2;
  transition: background-color 0.2s ease, opacity 0.2s ease;
  opacity: 1;
}

/* When not active, hide with opacity 0 */
.scl--cms-pseudo-after::before,
.scl--cms-pseudo-after::after {
  opacity: 0;
  transition: opacity 0.2s ease;
}`, "",{"version":3,"sources":["webpack://./src/layout-controller-mod/layout-serv/footer/css/sidebar.css"],"names":[],"mappings":"AAAA,gBAAgB;;AAEhB;EACE,sCAAsC;EACtC,qCAAqC;EACrC,sDAAsD;EACtD,gEAAgE;;EAEhE,SAAS;EACT,2CAA2C;EAC3C,8CAA8C;EAC9C,wCAAwC;EACxC,2DAA2D;EAC3D,6DAA6D;;EAE7D,UAAU;EACV,4EAA4E;EAC5E,iFAAiF;EACjF,8DAA8D;EAC9D,uEAAuE;EACvE,8EAA8E;;EAE9E,YAAY;EACZ,mDAAmD;EACnD,8CAA8C;EAC9C,sEAAsE;EACtE,iDAAiD;EACjD,gEAAgE;EAChE,yFAAyF;EACzF,8DAA8D;EAC9D,wFAAwF;;EAExF,UAAU;EACV,0CAA0C;EAC1C,2CAA2C;AAC7C;;AAEA;;6CAE6C;;AAE7C;EACE,eAAe;EACf,OAAO;EACP,uCAAuC;EACvC,2CAA2C;EAC3C,wDAAwD;EACxD,6CAA6C;EAC7C,qEAAqE;EACrE,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,wBAAwB;EACxB,YAAY;AACd;;AAEA;EACE,aAAa;AACf;;AAEA;;6CAE6C;;AAE7C;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,WAAW;AACb;;AAEA;;6CAE6C;;AAE7C;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;;6CAE6C;;AAE7C;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;;6CAE6C;;AAE7C;EACE,iBAAiB;EACjB,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,oDAAoD;EACpD,4CAA4C;EAC5C,WAAW;EACX,kDAAkD;EAClD,eAAe;EACf,6CAA6C;EAC7C,sBAAsB;AACxB;;AAEA;EACE,6CAA6C;EAC7C,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yDAAyD;AAC3D;;;;AAIA;;6CAE6C;;AAE7C;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;;6CAE6C;;AAE7C;EACE,OAAO;EACP,gGAAgG;EAChG,kBAAkB;EAClB,6DAA6D;EAC7D,yDAAyD;EACzD,kCAAkC;EAClC,iDAAiD;EACjD,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;EACjB,2BAA2B;AAC7B;;;AAGA;EACE,oEAAoE;EACpE,wDAAwD;AAC1D;;AAEA;;6CAE6C;;AAE7C;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;6CAE6C;;AAE7C;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,wDAAwD;EACxD,6CAA6C;EAC7C,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;6CAE6C;;AAE7C;EACE,kBAAkB;EAClB,sDAAsD;EACtD,MAAM;EACN,SAAS;EACT,YAAY;EACZ,6DAA6D;EAC7D,cAAc;EACd,UAAU;EACV,oBAAoB;AACtB;;AAEA;;6CAE6C;;AAE7C;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;;6CAE6C;;AAE7C;EACE,iBAAiB;EACjB,YAAY;EACZ,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,aAAa;EACb,iDAAiD;EACjD,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,2BAA2B;EAC3B,+DAA+D;EAC/D,0DAA0D;EAC1D,eAAe;EACf,6CAA6C;EAC7C,sBAAsB;EACtB,WAAW;EACX,gGAAgG;EAChG,kBAAkB;EAClB,6DAA6D;EAC7D,yDAAyD;EACzD,kCAAkC;EAClC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,6CAA6C;EAC7C,oBAAoB;AACtB;;AAEA;EACE,4DAA4D;EAC5D,gEAAgE;EAChE,oEAAoE;AACtE;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gDAAgD;EAChD,YAAY;EACZ,oBAAoB;EACpB,yDAAyD;EACzD,UAAU;AACZ;;AAEA,wDAAwD;AACxD;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,gDAAgD;EAChD,WAAW;EACX,yDAAyD;EACzD,UAAU;EACV,UAAU;AACZ;;AAEA,8EAA8E;AAC9E;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,gDAAgD;EAChD,WAAW;EACX,mDAAmD;EACnD,uEAAuE;EACvE,UAAU;EACV,UAAU;AACZ;;AAEA,0EAA0E;AAC1E;;EAEE,aAAa;AACf;;AAEA,yCAAyC;AACzC;;EAEE,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,gDAAgD;EAChD,YAAY;EACZ,oBAAoB;EACpB,UAAU;;AAEZ;;AAEA,wDAAwD;AACxD;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gDAAgD;EAChD,WAAW;EACX,yDAAyD;EACzD,UAAU;EACV,yDAAyD;EACzD,UAAU;AACZ;;AAEA,2EAA2E;AAC3E;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,gDAAgD;EAChD,WAAW;EACX,mDAAmD;EACnD,oEAAoE;EACpE,UAAU;EACV,yDAAyD;EACzD,UAAU;AACZ;;AAEA,yCAAyC;AACzC;;EAEE,UAAU;EACV,6BAA6B;AAC/B","sourcesContent":["/* sidebar.css */\n\n:root {\n  --scl--cms-layout-sidebar-width: 241px;\n  --scl--cms-layout-sidebar-top: 64.5px;\n  --scl--cms-layout-sidebar-bg: var(--neutralcolors-100);\n  --scl--cms-layout-sidebar-border-color: rgba(133, 140, 149, 0.1);\n\n  /* Item */\n  --scl--cms-layout-sidebar-item-height: 43px;\n  --scl--cms-layout-sidebar-item-padding: 0 22px;\n  --scl--cms-layout-sidebar-item-gap: 12px;\n  --scl--cms-layout-sidebar-item-hover-bg: var(--table-hover);\n  --scl--cms-layout-sidebar-item-active-bg: var(--action-hover);\n\n  /* Label */\n  --scl--cms-layout-sidebar-label-color: var(--typography-text-body-secondary);\n  --scl--cms-layout-sidebar-label-active-color: var(--typography-text-body-primary);\n  --scl--cms-layout-sidebar-label-font-size: var(--font-size-16);\n  --scl--cms-layout-sidebar-label-font-weight: var(--font-weight-regular);\n  --scl--cms-layout-sidebar-label-active-font-weight: var(--font-weight-regular);\n\n  /* Submenu */\n  --scl--cms-layout-sidebar-submenu-item-height: 39px;\n  --scl--cms-layout-sidebar-submenu-indent: 20px;\n  --scl--cms-layout-sidebar-submenu-line-color: rgba(138, 139, 143, 0.2);\n  --scl--cms-layout-sidebar-submenu-line-left: 30px;\n  --scl--cms-layout-sidebar-submenu-active-bg: var(--action-hover);\n  --scl--cms-layout-sidebar-submenu-active-label-color: var(--typography-text-body-primary);\n  --scl--cms-layout-sidebar-submenu-hover-bg: var(--table-hover);\n  --scl--cms-layout-sidebar-submenu-hover-label-color: var(--typography-text-body-primary);\n\n  /* Notch */\n  --scl--cms-layout-sidebar-notch-size: 10px;\n  --scl--cms-layout-sidebar-notch-radius: 5px;\n}\n\n/* ========================================\n   SIDEBAR CONTAINER\n   ======================================== */\n\n.scl--cms-layout-sidebar-container {\n  position: fixed;\n  left: 0;\n  top: var(--scl--cms-layout-sidebar-top);\n  width: var(--scl--cms-layout-sidebar-width);\n  height: calc(100vh - var(--scl--cms-layout-sidebar-top));\n  background: var(--scl--cms-layout-sidebar-bg);\n  border-right: 0.5px solid var(--scl--cms-layout-sidebar-border-color);\n  overflow-y: auto;\n  overflow-x: hidden;\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n  z-index: 100;\n}\n\n.scl--cms-layout-sidebar-container::-webkit-scrollbar {\n  display: none;\n}\n\n/* ========================================\n   SIDEBAR MENU\n   ======================================== */\n\n.scl--cms-layout-sidebar-menu {\n  display: flex;\n  flex-direction: column;\n  padding: 0;\n  width: 100%;\n}\n\n/* ========================================\n   MENU GROUP\n   ======================================== */\n\n.scl--cms-layout-sidebar-group {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n/* ========================================\n   ITEM WRAPPER (holds pseudo notch divs + button)\n   ======================================== */\n\n.scl--cms-layout-sidebar-item-wrapper {\n  position: relative;\n  width: 100%;\n}\n\n.scl--cms-layout-sidebar-submenu-item-wrapper {\n  position: relative;\n  width: 100%;\n}\n\n/* ========================================\n   MENU ITEM (Parent) - Button Reset + Styles\n   ======================================== */\n\n.scl--cms-layout-sidebar-item {\n  /* Button reset */\n  border: none;\n  margin: 0;\n  text-align: left;\n  font: inherit;\n  color: inherit;\n  /* Custom styles */\n  position: relative;\n  z-index: 0;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: var(--scl--cms-layout-sidebar-item-padding);\n  gap: var(--scl--cms-layout-sidebar-item-gap);\n  width: 100%;\n  height: var(--scl--cms-layout-sidebar-item-height);\n  cursor: pointer;\n  background: var(--scl--cms-layout-sidebar-bg);\n  box-sizing: border-box;\n}\n\n.scl--cms-layout-sidebar-item:focus {\n  outline: 2px solid var(--primarypalette-blue);\n  outline-offset: -2px;\n}\n\n.scl--cms-layout-sidebar-item:focus:not(:focus-visible) {\n  outline: none;\n}\n\n.scl--cms-layout-sidebar-item--active {\n  background: var(--scl--cms-layout-sidebar-item-active-bg);\n}\n\n\n\n/* ========================================\n   MENU ITEM ICON\n   ======================================== */\n\n.scl--cms-layout-sidebar-item-icon {\n  width: 20px;\n  height: 20px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.scl--cms-layout-sidebar-item-icon svg {\n  width: 20px;\n  height: 20px;\n  display: block;\n}\n\n/* ========================================\n   MENU ITEM LABEL\n   ======================================== */\n\n.scl--cms-layout-sidebar-item-label {\n  flex: 1;\n  font-family: var(--font-family-inter), -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  font-style: normal;\n  font-weight: var(--scl--cms-layout-sidebar-label-font-weight);\n  font-size: var(--scl--cms-layout-sidebar-label-font-size);\n  line-height: var(--line-height-24);\n  color: var(--scl--cms-layout-sidebar-label-color);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  user-select: none;\n  transition: color 0.2s ease;\n}\n\n\n.scl--cms-layout-sidebar-item--active .scl--cms-layout-sidebar-item-label {\n  font-weight: var(--scl--cms-layout-sidebar-label-active-font-weight);\n  color: var(--scl--cms-layout-sidebar-label-active-color);\n}\n\n/* ========================================\n   MENU ITEM CHEVRON\n   ======================================== */\n\n.scl--cms-layout-sidebar-item-chevron {\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  transition: transform 0.25s ease;\n}\n\n.scl--cms-layout-sidebar-item-chevron svg {\n  display: block;\n}\n\n.scl--cms-layout-sidebar-item-chevron--open {\n  transform: rotate(180deg);\n}\n\n/* ========================================\n   SUBMENU CONTAINER\n   ======================================== */\n\n.scl--cms-layout-sidebar-submenu {\n  display: flex;\n  flex-direction: row;\n  max-height: 0;\n  overflow: hidden;\n  transition: max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  background: var(--scl--cms-layout-sidebar-bg);\n  position: relative;\n}\n\n.scl--cms-layout-sidebar-submenu--open {\n  max-height: 600px;\n}\n\n/* ========================================\n   SUBMENU LEFT BORDER LINE\n   ======================================== */\n\n.scl--cms-layout-sidebar-submenu-line {\n  position: absolute;\n  left: var(--scl--cms-layout-sidebar-submenu-line-left);\n  top: 0;\n  bottom: 0;\n  width: 0.5px;\n  background: var(--scl--cms-layout-sidebar-submenu-line-color);\n  flex-shrink: 0;\n  z-index: 3;\n  pointer-events: none;\n}\n\n/* ========================================\n   SUBMENU ITEMS WRAPPER\n   ======================================== */\n\n.scl--cms-layout-sidebar-submenu-items {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n}\n\n/* ========================================\n   SUBMENU ITEM - Button Reset + Styles\n   ======================================== */\n\n.scl--cms-layout-sidebar-submenu-item {\n  /* Button reset */\n  border: none;\n  margin: 0;\n  left: 43px;\n  text-align: left;\n  font: inherit;\n  color: var(--scl--cms-layout-sidebar-label-color);\n  /* Custom styles */\n  position: relative;\n  z-index: 0;\n  display: flex;\n  align-items: center;\n  border-bottom-left-radius: 8px;\n  border-top-left-radius: 8px;\n  padding: 0 22px 0 var(--scl--cms-layout-sidebar-submenu-indent);\n  height: var(--scl--cms-layout-sidebar-submenu-item-height);\n  cursor: pointer;\n  background: var(--scl--cms-layout-sidebar-bg);\n  box-sizing: border-box;\n  width: 100%;\n  font-family: var(--font-family-inter), -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  font-style: normal;\n  font-weight: var(--scl--cms-layout-sidebar-label-font-weight);\n  font-size: var(--scl--cms-layout-sidebar-label-font-size);\n  line-height: var(--line-height-24);\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  user-select: none;\n}\n\n.scl--cms-layout-sidebar-submenu-item:focus {\n  outline: none;\n}\n\n.scl--cms-layout-sidebar-submenu-item:focus-visible {\n  outline: 2px solid var(--primarypalette-blue);\n  outline-offset: -2px;\n}\n\n.scl--cms-layout-sidebar-submenu-item--active {\n  background: var(--scl--cms-layout-sidebar-submenu-active-bg);\n  color: var(--scl--cms-layout-sidebar-submenu-active-label-color);\n  font-weight: var(--scl--cms-layout-sidebar-label-active-font-weight);\n}\n\n.scl--cms-pseudo-before {\n  position: absolute;\n  top: -7px;\n  right: 0;\n  width: var(--scl--cms-layout-sidebar-notch-size);\n  height: 100%;\n  pointer-events: none;\n  transition: background-color 0.4s ease, opacity 0.4s ease;\n  z-index: 2;\n}\n\n/* Layer 1 — active bg block that fills the notch area */\n.scl--cms-pseudo-before.submenu-active::after {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: var(--scl--cms-layout-sidebar-notch-size);\n  height: 7px;\n  background: var(--scl--cms-layout-sidebar-item-active-bg);\n  z-index: 1;\n  opacity: 1;\n}\n\n/* Layer 2 — sidebar bg with border-bottom-right-radius that cuts the corner */\n.scl--cms-pseudo-before.submenu-active::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: var(--scl--cms-layout-sidebar-notch-size);\n  height: 7px;\n  background-color: var(--scl--cms-layout-sidebar-bg);\n  border-bottom-right-radius: var(--scl--cms-layout-sidebar-notch-radius);\n  z-index: 2;\n  opacity: 1;\n}\n\n/* First item: suppress top notch entirely — nothing above to carve into */\n.scl--cms-pseudo-before.first-item-special::before,\n.scl--cms-pseudo-before.first-item-special::after {\n  display: none;\n}\n\n/* When not active, hide with opacity 0 */\n.scl--cms-pseudo-before::before,\n.scl--cms-pseudo-before::after {\n  opacity: 0;\n}\n\n.scl--cms-pseudo-after {\n  position: absolute;\n  bottom: -7px;\n  right: 0;\n  width: var(--scl--cms-layout-sidebar-notch-size);\n  height: 100%;\n  pointer-events: none;\n  z-index: 2;\n  \n}\n\n/* Layer 1 — active bg block that fills the notch area */\n.scl--cms-pseudo-after.submenu-active::after {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  width: var(--scl--cms-layout-sidebar-notch-size);\n  height: 7px;\n  background: var(--scl--cms-layout-sidebar-item-active-bg);\n  z-index: 1;\n  transition: background-color 0.2s ease, opacity 0.2s ease;\n  opacity: 1;\n}\n\n/* Layer 2 — sidebar bg with border-top-right-radius that cuts the corner */\n.scl--cms-pseudo-after.submenu-active::before {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  width: var(--scl--cms-layout-sidebar-notch-size);\n  height: 7px;\n  background-color: var(--scl--cms-layout-sidebar-bg);\n  border-top-right-radius: var(--scl--cms-layout-sidebar-notch-radius);\n  z-index: 2;\n  transition: background-color 0.2s ease, opacity 0.2s ease;\n  opacity: 1;\n}\n\n/* When not active, hide with opacity 0 */\n.scl--cms-pseudo-after::before,\n.scl--cms-pseudo-after::after {\n  opacity: 0;\n  transition: opacity 0.2s ease;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
